import React, { Component, useState, useEffect } from 'react';
import { getCADTopologyTagNames, getTestRunsFromTagName } from './../../UserFunctions';
import DataTableExtensions from 'react-data-table-component-extensions';
import VirtualizedSelect from 'react-virtualized-select';
import DataTable from 'react-data-table-component';
import 'react-data-table-component-extensions/dist/index.css';
//import 'react-select/dist/react-select.css';
//import 'react-virtualized/styles.css'
//import 'react-virtualized-select/styles.css'
import PropTypes from 'prop-types';


const ExpandableComponent = ( { data, handleTestRun } ) => {
    const [testRun, setTestRun] = useState('');
    const [availableTestRuns, setAvailableTestRuns] = useState([]);

    useEffect(() => {
        const { job_id } = data;

        getTestRunsFromTagName({ job_id }).then((response) => {
            if(response && response.status === 200) {
                const { message } = response.data;
                if(message === 'fetched_test_runs') {
                    setAvailableTestRuns(response.data['test_runs'])
                }
            }
        });
    }, )

    const onTestRunChange = (testRunId) => {
        setTestRun(testRunId.label);
    }

    return (
        <div data-test = 'closedLoopPerformanceReportTagNamesCADComponent' className='row'>
            <div className='col-12'>
                <div className='card'>
                    <div className='card-body'>
                        <div className='row'>
                            <div className='col-6'>
                                <VirtualizedSelect
                                    options={availableTestRuns}
                                    onChange={(testRun) => { onTestRunChange(testRun) }}
                                    value={testRun}
                                />
                            </div>
                            <div className='col-6'>
                                { testRun !== '' ?
                                 <button className='btn' style={{ backgroundColor: '#753DFF', color: 'white' }} onClick={(e) => handleTestRun(e, {testRun}) } >{ testRun }</button>
                                 : undefined }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


class TagNames extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: []
        }
    }

    componentDidMount(){
        document.getElementsByClassName('print')[0].style.visibility = 'hidden';
        document.getElementsByClassName('download')[0].style.visibility = 'hidden';

        getCADTopologyTagNames().then((response) => {
            if(response && response.status === 200) {
                const { message } = response.data
                if(message === 'fetched_records') {
                    this.setState((prevState) => {
                        return {
                            ...prevState,
                            data: response.data['records']
                        }
                    })
                }
            }
        })
    }

    handleTestRun = (event, { testRun }) => {
        const url = `/close_loop/performance_report/${testRun}`
        this.props.history.push(url);
    }

    render() {
        const columns = [
            {
                name: 'Tag Name',
                selector: 'topology_tag_name',
                sortable: true,
                cell: row => <h5>{ row.topology_tag_name }</h5>,
                left: true
            },
            {
                name: 'Description',
                selector: 'description',
                sortable: true,
                cell: row => <h5>{ row.description }</h5>,
                center: true
            }
        ]
        const tableData = {
            columns,
            data: this.state.data
        }

        const customStyles = {
            rows: {
                style: {
                    backgroundColor: '#C7C9FF !important',
                    color : '#464646',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    borderBottom: '12px solid #FFFFFF',
                }
            },
            headCells: {
                style: {
                    backgroundColor: 'white',
                    color: '#464646',
                    borderBottom: '4px solid #622AD8',
                    textAlign: 'center',
                }
            }
        }

        return (
            <div className='container-fluid'>
                <div className='row' style={{ 'paddingTop': '3%' }}>
                    <div className='col-12'>
                        <div className='card'>
                            <div className='card-header' style={{ backgroundColor: "#757AF7", color: "white" }}>
                                <h4>CAD Topology Tag Names</h4>
                            </div>
                            <div className='card-body'>
                                <div className='row'>
                                    <div className='col-12'>
                                        <DataTableExtensions
                                            {...tableData}
                                        >
                                            <DataTable
                                                defaultSortField='topology_tag_name'
                                                pagination
                                                customStyles={customStyles}
                                                expandableRows
                                                expandableRowDisabled={ row => row.disabled }
                                                expandableRowsComponent={ <ExpandableComponent handleTestRun={this.handleTestRun}/> }
                                            />
                                        </DataTableExtensions>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
ExpandableComponent.propTypes={
data:PropTypes.string,
handleTestRun:PropTypes.string,
}
ExpandableComponent.defaultProps= {
data:[],
handleTestRun:[],
}

TagNames.propTypes={
history:PropTypes.string,
}
TagNames.defaultProps= {
history:[],
}
// class TagNames extends Component {
//     constructor(props) {
//         super(props)
//         this.state = {
//             data: []
//         }
//     }

//     componentDidMount(){
//         document.getElementsByClassName('print')[0].style.visibility = 'hidden';
//         document.getElementsByClassName('download')[0].style.visibility = 'hidden';

//         getCADTopologyTagNames().then((response) => {
//             if(response && response.status === 200) {
//                 const { message } = response.data
//                 if(message === 'fetched_records') {
//                     this.setState((prevState) => {
//                         return {
//                             ...prevState,
//                             data: response.data['records']
//                         }
//                     })
//                 }
//             }
//         })
//     }

//     handleTestRun = (event, { testRun }) => {
//         const url = `/close_loop/performance_report/${testRun}`
//         this.props.history.push(url);
//     }
//     const ExpandableComponent = ( { data, handleTestRun } ) => {
//         const [testRun, setTestRun] = useState('');
//         const [availableTestRuns, setAvailableTestRuns] = useState([]);

//         useEffect(() => {
//             const { job_id } = data;

//             getTestRunsFromTagName({ job_id }).then((response) => {
//                 if(response && response.status === 200) {
//                     const { message } = response.data;
//                     if(message === 'fetched_test_runs') {
//                         setAvailableTestRuns(response.data['test_runs'])
//                     }
//                 }
//             });
//         }, [])

//         const onTestRunChange = (testRunId) => {
//             setTestRun(testRunId.label);
//         }

export default TagNames;
